export enum TIME_INPUT_FORMAT {
  MILITARY_SHORT = 'h:mma', // 12:00am
  MILITARY = 'HH:mm', // 00:00
}

export const TIME_FORMAT = TIME_INPUT_FORMAT.MILITARY_SHORT
